import React from 'react'
import ContentLoader from 'react-content-loader' 

const FluidLoaderHalf = () => {
    return (
        <>
        <div className="text-center mx-auto">
        <ContentLoader
            speed={2}
            width={800}
            height={300}
            viewBox="0 0 800 300"
            backgroundColor="#d9d9d9"
            foregroundColor="#ecebeb"
        >
            <rect x="0" y="0" width="800" height="300" />
        </ContentLoader>
        </div>
        </>
    )
}

export default FluidLoaderHalf
